export const NEUTRAL_INPUT = {
    left: false,
    right: false,
    jump: false,
    attack: false,
};
/** The scalar fields a client reconciler mirrors from server truth. */
export const BODY_FIELDS = [
    "x",
    "y",
    "vx",
    "vy",
    "facing",
    "grounded",
    "coyote",
    "jumpBuffer",
    "jumpHeld",
    "jumping",
    "frozen",
    "stunned",
];
//# sourceMappingURL=types.js.map